// extracted by mini-css-extract-plugin
export default {"form":"ModalForm_form__slhYb","controlButtons":"ModalForm_controlButtons__A0sUk"};